import * as Sentry from '@sentry/browser';

const localStorageAvailable = () => {
  const test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};

const storeData = (key, data) => {
  if (!localStorageAvailable()) {
    return;
  }
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    Sentry.captureException(error);
  }
};

const getData = (key) => {
  if (!localStorageAvailable()) {
    return null;
  }
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return localStorage.getItem(key);
  }
};

export { getData, localStorageAvailable, storeData };
